import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const ChartBoxMultipleOutline = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 14 14'
    >
      <path
        d='M13.3333 10.6663V2.66634H5.33334V10.6663M14.6667 10.6663C14.6667 11.3997 14.0667 11.9997 13.3333 11.9997H5.33334C4.60001 11.9997 4.00001 11.3997 4.00001 10.6663V2.66634C4.00001 1.93301 4.60001 1.33301 5.33334 1.33301H13.3333C14.0667 1.33301 14.6667 1.93301 14.6667 2.66634M10.6667 13.333V14.6663H2.66668C1.93334 14.6663 1.33334 14.0663 1.33334 13.333V4.66634H2.66668V13.333M10.6667 7.33301H12V9.33301H10.6667M8.66668 3.99967H10V9.33301H8.66668M6.66668 5.33301H8.00001V9.33301H6.66668V5.33301Z'
        fill='#F8F8F8'
      />
    </SvgIcon>
  );
};

export default ChartBoxMultipleOutline;
